// Web module: devices (people lane). Devices list with one icon column per device check, and a Compliance tab on the
// device detail page. The contract is in ../README.md.
import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'

export const module: WebModule = {
  routes: [],
  entityOverrides: {
    device: {
      ListPage: lazyComponent(() => import('./DevicesListPage'), 'DevicesListPage'),
      detailTabs: [
        {
          id: 'compliance',
          label: 'Compliance',
          order: 12,
          component: lazyComponent(() => import('./DeviceComplianceTab'), 'DeviceComplianceTab'),
        },
      ],
    },
  },
}
